import { useEffect, useState } from "react";
import { useSiteSettings } from "../lib/settings";
import Layout from "./Layout";
import Maintenance from "../pages/Maintenance";

/** Maintenance gate — wraps the public Layout.
 * - If settings.maintenance_enabled is false → render <Layout /> (normal site).
 * - If true AND no admin token → render <Maintenance />.
 * - If true AND admin token present → render <Layout /> + a small "admin view" banner.
 */
export default function MaintenanceGate() {
  const { settings, loading } = useSiteSettings();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const check = () => setIsAdmin(!!localStorage.getItem("ecogest_token"));
    check();
    window.addEventListener("storage", check);
    return () => window.removeEventListener("storage", check);
  }, []);

  if (loading || !settings) {
    return <div className="min-h-screen bg-black" data-testid="loading-splash" />;
  }

  if (settings.maintenance_enabled && !isAdmin) {
    return <Maintenance />;
  }

  if (settings.maintenance_enabled && isAdmin) {
    return (
      <div data-testid="admin-maintenance-view">
        <div className="bg-[#E60000] text-white text-[10px] sm:text-xs uppercase tracking-[0.2em] py-2 px-4 text-center font-semibold">
          Mode maintenance actif — visible uniquement par vous (admin)
        </div>
        <Layout />
      </div>
    );
  }

  return <Layout />;
}
